export default "__VITE_ASSET__Bwe9TX9L__"